var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"china_map_box"}},[_c('div',{attrs:{"id":"china_map"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// D:/ADO_CICD/tools/nodejs/portal/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6f70b10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!D:/ADO_CICD/tools/nodejs/portal/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/china.vue
// module id = null
// module chunks = 